export const POST_ID = document.querySelector('input[name="post_ID"]')?.value ?? '0';

export const TITLES_LIST = [
  'Uso da palavra-chave ao longo da página',
  'Tamanho de título apropriado',
  'Evitar o uso excessivo da palavra-chave no documento',
  'Uso consistente das palavras-chave no documento',
  'Não usar mais de uma tag H1',
  'Uso de palavras-chave adequadas na tag H1',
  'Quantidade de palavras no conteúdo',
  'Uso exato da palavra-chave no documento',
  'Evitar o uso excessivo da palavra-chave no título',
  'Quantidade de links externos',
  'Autoridade da palavra-chave nesta página',
  'Quantidade de links internos',
  'Palavra-chave no primeiro parágrafo',
];

export const HEADERS_CONTENT_URLENCODED = { 'Content-Type': 'application/x-www-form-urlencoded' };

export const TIPO_ANALISE = {
  Ortografia: 'ortografia',
  Gramatica: 'gramatica',
  UsoVirgula: 'virgula',
  VozPassiva: 'voz-passiva',
  Legibilidade: 'legibilidade',
};

export const ROTAS_WP = {
  DASHBOARD: '/wp-admin/admin.php',
  POST_NEW: '/wp-admin/post-new.php',
  POST_EDIT: '/wp-admin/post.php',
};

export const ROTAS_OPTI = {
  LOGS: '?page=logs',
  ADD: '?page=optimarketing&add=true',
  DASHBOARD: '?page=optimarketing',
  ANALYTICS: '?page=optimarketing&analytics=true',
  CRIAR_ARTIGO: '?page=optimarketing&criar-artigo=true',
};
